module.exports = __webpack_public_path__ + "static/media/image6.6870581d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image6.jpg
// module id = 40
// module chunks = 0